import { CrudEndpoint } from '@/api/common/CrudEndpoint';
import { ProductCategoryOptionDTO } from '@/api/dto/ProductCategoryOptionDTO';

export class ProductCategoryOptionsCRUD extends CrudEndpoint<ProductCategoryOptionDTO> {
  constructor() {
    super('productcategoryoption');
  }
}
